/** Shared in-app paths used by auth bootstrap and return-URL handling. */
export const AppRoute = {
  /** Auth0 / Pulse user bootstrap screen. */
  Loading: '/loading',

  /** Shown when Pulse user data cannot be loaded for a non-auth reason. */
  LoginUnsuccessful: '/login-unsuccessful'
} as const;

export type AppRoute = (typeof AppRoute)[keyof typeof AppRoute];
